import { Dispatch, SetStateAction, useContext } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { mainContext } from "@ts/constants";
import { IMainContext } from "@ts/common-types";
import { FaExternalLinkAlt } from "react-icons/fa";

const FilterCellRenderer = (
    params: ICellRendererParams,
    setShow: Dispatch<SetStateAction<boolean>>
) => {
    const { setRulesFilterData } = useContext<IMainContext>(mainContext);
    const data = params.data;
    const filterModalHandler = () => {
        setShow(true);
        setRulesFilterData(data);
    };

    return (
        <>
            {params.node.rowPinned ? null : (
                <button
                    className="btn"
                    data-bs-toggle="modal"
                    data-bs-target="#filter-modal"
                    onClick={filterModalHandler}
                >
                    <FaExternalLinkAlt aria-hidden="true"/>
                </button>
            )}
        </>
    );
};

export default FilterCellRenderer;
